import axios from 'axios';
import { GetAPIEndpoint } from '../../configuration';

function getToken() {
    const tokenString =
        localStorage.getItem('access_token') ||
        sessionStorage.getItem('access_token') ||
        '';

    return tokenString;
}

function isBypassUrl() {
    const href = window.location.href;

    return (
        href.includes('/login') ||
        href.includes('mindtickle/score') ||
        href.includes('mindtickle/callback') ||
        href.includes('mindtickle/okta') ||
        href.includes('mindtickle/redirect') ||
        href.includes('/sso') ||
        href.includes('/callback')
    );
}

const auth = {
    getToken,

    isAuthenticated: () => {
        return getToken().length > 0;
    },

    handleUnauthorizedRedirect: () => {
        if (!auth.isAuthenticated() && !isBypassUrl()) {
            window.location.assign('/login');
        }
    },

    authenticate(email, password, cb) {
        axios
            .post(`${GetAPIEndpoint()}/token`, { email, password })
            .then((response) => {
                if (response.status !== 200 || !response?.data?.access_token) {
                    cb({ success: false });
                    return;
                }

                localStorage.setItem('access_token', response.data.access_token);
                cb({ success: true });
            })
            .catch((error) => {
                cb({ success: false });
                return Promise.reject(error);
            });
    },

    authenticateSSO(token, cb) {
        if (!token) {
            cb({ success: false });
            return;
        }

        axios
            .post(`${GetAPIEndpoint()}/api/sso`, { token })
            .then((response) => {
                if (response.status !== 200 || !response?.data?.access_token) {
                    cb({ success: false });
                    return;
                }

                localStorage.setItem('access_token', response.data.access_token);
                cb({ success: true });
            })
            .catch((error) => {
                cb({ success: false });
                return Promise.reject(error);
            });
    },

    signout(cb) {
        localStorage.removeItem('access_token');
        sessionStorage.removeItem('access_token');
        cb();
    },
};

export default auth;
